import React from "react";
import "./Navbar.css";

const Navbar = () => {
  return (
    <nav>
      <h1>Heels Villa</h1>
    </nav>
  );
};

export default Navbar;
